import SizeSubtitleWithTableModal from './SizeSubtitleWithTableModal'

const CHEST_SIZE_TABLE_DATA = {
  thead: [{ defaultValue: 'Spoke Top Size', value: 'Chest Size' }],
  tbody: [
    { defaultValue: 'S', value: '36-38' },
    { defaultValue: 'M', value: '39' },
    { defaultValue: 'M+', value: '40' },
    { defaultValue: 'L', value: '41' },
    { defaultValue: 'L+', value: '42' },
    { defaultValue: 'XL', value: '44-46' },
    { defaultValue: 'XXL', value: '48-50' },
    { defaultValue: 'XXXL', value: '52' }
  ]
} as const

type ChestSizeSubtitleWithModalProps = {
  modalOpen: boolean
  toggleModal: () => void
}

function ChestSizeSubtitleWithModal({
  modalOpen,
  toggleModal
}: ChestSizeSubtitleWithModalProps) {
  return (
    <SizeSubtitleWithTableModal
      modalOpen={modalOpen}
      toggleModal={toggleModal}
      sizeType="Chest Size"
      tableData={CHEST_SIZE_TABLE_DATA}
      title="What's my chest size?"
      byline="The Jack is cut in traditional tailoring chest sizes — 36″ through to 44″. Consult this canny chart to see how this corresponds with our standard top sizes."
    />
  )
}

export default ChestSizeSubtitleWithModal
